import { useState, useRef } from 'react';

import { Marker } from '../../../types/iMediaPlayer';
import MediaMethods from '../../atoms/mediaDataCollector/MediaMethods';
import FullScreenButton from '../../atoms/playerButtons/FullScreenButton';
import PlayButton from '../../atoms/playerButtons/PlayButton';
import ProgressBar from '../../atoms/playerButtons/ProgressBar';
import SettingsButton from '../../atoms/playerButtons/SettingsButton';
import VolumeButton from '../../atoms/playerButtons/VolumeButton';

import './VideoPlayer.scss';

interface VideoPlayerProps {
  url: string;
  markers?: Marker[];
  onPlay?: () => void;
  className?: string;
}

export default function VideoPlayer({ url, markers = [], onPlay, className = '' }: VideoPlayerProps) {
  const [duration, setDuration] = useState<string>('0');
  const [playerCurrentTime, setPlayerCurrentTime] = useState<number>(0);
  const [showControlBar, setShowControlBar] = useState<boolean>(false);
  const [hideControlBarTimer, setHideControlBarTimer] = useState<any>(null);
  const videoIdRef = useRef<string>('');
  const playerRef = useRef<HTMLAudioElement | any>(null);
  const progressBarRef = useRef<HTMLInputElement>(null);
  const isYoutubeRef = useRef<boolean>(false);

  const regExp =
    /(?:youtu\.be\/|youtube(?:-nocookie)?\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=|\/sandalsResorts#\w\/\w\/.*\/))([^/&]{10,12})/;
  const videoId = url.match(regExp);
  if (videoId != null) {
    videoIdRef.current = videoId[1];
    isYoutubeRef.current = true;
  } else {
    videoIdRef.current = url;
  }

  async function updateProgressBarAndPlayerCurrentTime() {
    progressBarRef.current!.style.setProperty(
      '--seeker-width',
      `${(parseInt(progressBarRef.current!.value) / parseInt(progressBarRef.current!.max)) * 100}%`
    );
    setPlayerCurrentTime(await MediaMethods.getCurrentTime(playerRef));
  }

  async function setPlayerDuration() {
    setDuration(MediaMethods.convertSecondsToTime(await MediaMethods.getDuration(playerRef)));
    progressBarRef.current!.max = (await MediaMethods.getDuration(playerRef)).toString();
  }

  async function displayControlBar() {
    const elements = Array.from(
      document.getElementsByClassName('media-player-container-fullscreen') as HTMLCollectionOf<HTMLElement>
    );

    if (elements.length !== 0) {
      elements[0].style.bottom = '0px';
      if (hideControlBarTimer != null) {
        clearTimeout(hideControlBarTimer);
        setHideControlBarTimer(null);
      }

      setHideControlBarTimer(
        setTimeout(() => {
          if (elements[0].classList.contains('media-player-container-fullscreen')) {
            elements[0].style.bottom = '-70px';
          }
        }, 2000)
      );
    }

    const visibleControlBar = Array.from(
      document.getElementsByClassName('media-player-container-normal-screen') as HTMLCollectionOf<HTMLElement>
    );

    if (visibleControlBar.length !== 0) {
      visibleControlBar[0].style.opacity = '1';
      if (hideControlBarTimer != null) {
        clearTimeout(hideControlBarTimer);
        setHideControlBarTimer(null);
      }

      setHideControlBarTimer(
        setTimeout(() => {
          if (visibleControlBar[0].classList.contains('media-player-container-normal-screen')) {
            visibleControlBar[0].style.opacity = '0';
          }
        }, 2000)
      );
    }
  }

  /*
  const opts = {
    playerVars: {
      controls: 0,
      modestbranding: 1,
    },
  };
*/

  return (
    <div id={videoIdRef && videoIdRef.current} className={`video-player ${className}`} onMouseMove={displayControlBar}>
      <video className="video" ref={playerRef} src={url} onLoadedMetadata={setPlayerDuration} />
      {/*            <YouTube
              className={`media-player-youtube-video w-full`}
              ref={playerRef}
              //@ts-ignore
              opts={opts}
              videoId={videoIdRef.current}
              onReady={setPlayerDuration}
            />*/}
      <div className={`control-bar ${showControlBar ? '' : 'hidden'}`}>
        {/*         <SkipButtons skipTime={content.skipTime} playerRef={playerRef}>

          </SkipButtons>*/}

        <span className="media-player-time">{MediaMethods.convertSecondsToTime(playerCurrentTime)}</span>
        <PlayButton
          playerRef={playerRef}
          progressBarRef={progressBarRef}
          updateProgressBarAndPlayerCurrentTime={updateProgressBarAndPlayerCurrentTime}
          onClickPlay={onPlay}
        />
        <ProgressBar
          className="grow"
          playerRef={playerRef}
          progressBarRef={progressBarRef}
          updateProgressBarAndPlayerCurrentTime={updateProgressBarAndPlayerCurrentTime}
          markers={markers}
          duration={duration}
          sectionId="aab"
        />
        <span className="media-player-time">{duration}</span>
        <VolumeButton playerRef={playerRef} />
        <SettingsButton playerRef={playerRef} />
        <FullScreenButton
          videoContainerId={videoIdRef && videoIdRef.current}
          playerRef={playerRef}
          setShowControlBar={setShowControlBar}
        />
      </div>
    </div>
  );
}
